export const adminListReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADMIN_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADMIN_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    case "ADMIN_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const adminAccessCodeListReducer = (state = {}, action) => {
  switch (action.type) {
    case "ACCESS_CODE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ACCESS_CODE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    case "ACCESS_CODE_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};


export const addAccessCodeReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_ACCESS_CODE_REQUEST":
      return {
        loading: true,
        isAccessCodeAdded: false,
      };
    case "ADD_ACCESS_CODE_SUCCESS":
      return {
        loading: false,
        isAccessCodeAdded: true,
        data: action.payload,
      };
    case "ADD_ACCESS_CODE_FAIL":
      return {
        loading: false,
        isAccessCodeAdded: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const addAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_ADMIN_REQUEST":
      return {
        loading: true,
        isAdded: false,
      };
    case "ADD_ADMIN_SUCCESS":
      return {
        loading: false,
        isAdded: true,
        data: action.payload,
      };
    case "ADD_ADMIN_FAIL":
      return {
        loading: false,
        isAdded: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const removeAccessCodeReducer = (state = {}, action) => {
  switch (action.type) {
    case "REMOVE_ACCESS_CODE_REQUEST":
      return {
        loading: true,
        isAccessCodeRemoved: false,
      };
    case "REMOVE_ACCESS_CODE_SUCCESS":
      return {
        loading: false,
        isAccessCodeRemoved: true,
        data: action.payload,
      };
    case "REMOVE_ACCESS_CODE_FAIL":
      return {
        loading: false,
        isAccessCodeRemoved: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const editAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case "EDIT_ADMIN_REQUEST":
      return {
        loading: true,
        isEdited: false,
      };
    case "EDIT_ADMIN_SUCCESS":
      return {
        loading: false,
        isEdited: true,
        data: action.payload,
      };
    case "EDIT_ADMIN_FAIL":
      return {
        loading: false,
        isEdited: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const viewAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case "VIEW_ADMIN_REQUEST":
      return {
        loading: true,
        isEdited: false,
        singleAdmin: null,
      };
    case "VIEW_ADMIN_SUCCESS":
      return {
        loading: false,
        isEdited: true,
        singleAdmin: action.payload,
      };
    case "VIEW_ADMIN_FAIL":
      return {
        loading: false,
        isEdited: false,
        error: action.payload,
        singleAdmin: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const enumsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_ENUMS_REQUEST":
      return {
        loading: true,
        enumsData: null,
      };
    case "GET_ENUMS_SUCCESS":
      return {
        loading: false,
        enumsData: action.payload,
      };
    case "GET_ENUMS_FAILED":
      return {
        loading: false,
        getEnums: action.payload,
      };
    default:
      return state;
  }
};
